import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/unsubscribe")({
  head: () => ({ meta: [{ title: "Odjava od e-pošte — kupish.si" }, { name: "robots", content: "noindex" }] }),
  component: Page,
});

type State =
  | { kind: "loading" }
  | { kind: "valid"; email: string }
  | { kind: "already" }
  | { kind: "invalid" }
  | { kind: "confirming" }
  | { kind: "done" }
  | { kind: "error"; message: string };

function Page() {
  const [state, setState] = useState<State>({ kind: "loading" });
  const [token, setToken] = useState<string>("");

  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get("token") ?? "";
    setToken(t);
    if (!t) { setState({ kind: "invalid" }); return; }
    (async () => {
      try {
        const r = await fetch(`/email/unsubscribe?token=${encodeURIComponent(t)}`);
        if (r.status === 200) {
          const j = await r.json().catch(() => ({}));
          if (j.already_unsubscribed) setState({ kind: "already" });
          else setState({ kind: "valid", email: j.email ?? "" });
        } else if (r.status === 410) setState({ kind: "already" });
        else setState({ kind: "invalid" });
      } catch (e: any) {
        setState({ kind: "error", message: e?.message ?? "Napaka" });
      }
    })();
  }, []);

  async function confirm() {
    setState({ kind: "confirming" });
    try {
      const r = await fetch("/email/unsubscribe", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ token }),
      });
      if (r.ok) setState({ kind: "done" });
      else setState({ kind: "error", message: "Odjava ni uspela. Poskusite znova." });
    } catch (e: any) {
      setState({ kind: "error", message: e?.message ?? "Napaka" });
    }
  }

  return (
    <section className="mx-auto max-w-xl px-6 py-24">
      <div className="eyebrow">E-pošta</div>
      <h1 className="font-serif text-5xl mt-3">Odjava od e-pošte</h1>

      {state.kind === "loading" && <p className="mt-8 text-muted-foreground">Preverjam povezavo…</p>}

      {state.kind === "valid" && (
        <>
          <p className="mt-8">
            Želite odjaviti naslov{state.email ? <> <strong>{state.email}</strong></> : ""} od e-poštnih sporočil kupish.si?
          </p>
          <p className="mt-3 text-sm text-muted-foreground">
            Še naprej boste prejemali nujna sporočila, povezana z vašimi naročili.
          </p>
          <button onClick={confirm} className="mt-8 bg-primary text-primary-foreground px-6 py-3 text-sm">
            Potrdi odjavo
          </button>
        </>
      )}

      {state.kind === "confirming" && <p className="mt-8 text-muted-foreground">Odjavljam…</p>}

      {state.kind === "done" && (
        <p className="mt-8">Uspešno ste odjavljeni. Hvala, da ste bili z nami.</p>
      )}

      {state.kind === "already" && (
        <p className="mt-8">Ta naslov je že odjavljen od naše e-pošte.</p>
      )}

      {state.kind === "invalid" && (
        <p className="mt-8 text-destructive">Povezava ni veljavna ali je potekla.</p>
      )}

      {state.kind === "error" && (
        <p className="mt-8 text-destructive">{state.message}</p>
      )}
    </section>
  );
}
